import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
//@ts-ignore
import { IS_LONG_TERM_OLYMP_ACCEPTED } from '@yandex-int/k-common/constants';
import {
    Modal,
    ModalCloseProps,
    ModalOffer,
    PersonalAgreement,
    useGeneratePath,
    useStaticUrls,
} from 'platform-components';
import { CloseButton } from 'platform-components/src/components/close-button/_view/close-button_view_outer';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { useMount } from 'react-use';
import ym from 'react-yandex-metrika';

import { grantUserRightsRequest } from 'common.components/user/actions';
import { getGrantRightsLoadingStatus } from 'common.components/user/selectors';

const sendMetrika = (action: string) => {
    ym('reachGoal', 'teacher_olymp_legal_popup', {
        action,
    });
};

export const SpecCourseModalOffer = () => {
    const dispatch = useDispatch();
    const getRouterPath = useGeneratePath();
    const history = useHistory();
    const { labLibraryMain } = useStaticUrls();
    const loadingStatus = useSelector(getGrantRightsLoadingStatus);

    useMount(() => {
        sendMetrika('show');
    });

    const handleSubmit = async () => {
        sendMetrika('take_part');
        // @ts-ignore не понимает js-ную переменную IS_LONG_TERM_OLYMP_ACCEPTED
        dispatch(grantUserRightsRequest({ [IS_LONG_TERM_OLYMP_ACCEPTED]: true }));
    };

    const handleClose = () => {
        sendMetrika('close');
        history.push(getRouterPath(labLibraryMain));
    };

    return (
        <ModalOffer
            //@ts-ignore - EDUCATION-37077: [react-update]: fixme typings: Хочет ReactNode вместo JSX.Element
            Close={(closeProps: ModalCloseProps) => (
                <CloseButton {...closeProps} position={CloseButton.POSITION.ABSOLUTE} />
            )}
            buttonText="specCourse.teacher.modalOffer.buttonText"
            descriptionText="specCourse.teacher.newModalOffer.descriptionText"
            hasClose={true}
            headerText="specCourse.teacher.newModalOffer.headerText"
            mix="spec-course-modal-offer"
            onRequestClose={handleClose}
            onSubmit={handleSubmit}
            opened={true}
            personalAgreementLinkConfig={[PersonalAgreement.personalAgreementLinks.olympLink]}
            progress={loadingStatus === LOADING_STATUSES.LOADING}
            theme={Modal.THEMES.TEACHER}
            view={ModalOffer.VIEW.STRICT}
        />
    );
};
